export const state = () => ({
    selectedPublications: new Set(),
})

export const getters = {
    selectedPublications: (state) => {
        return state.selectedPublications
    },
}

export const mutations = {
    setSelectedPublications(state, payload) {
        state.selectedPublications = payload
    },
}

export const actions = {
    addPublication({ commit, state }, id) {
        const updatedSet = new Set(state.selectedPublications)
        updatedSet.add(id)
        commit('setSelectedPublications', updatedSet)
    },
    removePublication({ commit, state }, id) {
        const updatedSet = new Set(state.selectedPublications)
        updatedSet.delete(id)
        commit('setSelectedPublications', updatedSet)
    },
    clearPublications({ commit }) {
        commit('setSelectedPublications', new Set())
    },
}
